import React, { useContext, useEffect, useState } from "react";
import classes from "./ProfileComponents.module.scss";
import { useFormContext, Controller } from "react-hook-form";
import { E2Data } from "../../lib/ddd/ddd";
import { Skeleton } from "@mui/material";
import { Spinner } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { OrgIdContext } from "../../store/orgId_context";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import WarningTooltip from "./WarningTooltip";
// import { yupResolver } from "@hookform/resolvers/yup";
// import * as yup from "yup";

const e2Data = new E2Data("EU_InvoicesR_ISO3166_2Subd");
//e2Data.filter = "EinvoicesOrder <> null";
//e2Data.orderBy = "EinvoicesOrder asc, CountryNameOriginal asc";
//e2Data.take = null;

const GeneralInfo = ({
  isEditMode,
  // name,
  // address,
  // postCode,
  // cityName,
  // countryCode,
  onFormReset,
  shouldReset,
  // values,
  countriesList,
  scrList,
  profileData
}) => {
  const { t } = useTranslation();
  const {sessionInfo} = useContext(OrgIdContext)
  // const schema = yup.object().shape({
  //   Name: yup.string().default(name).required("Required field!"),
  //   Address: yup.string().default(address),
  //   PostCode: yup.string().default(postCode).required("Required field!"),
  //   CityName: yup.string().default(cityName).required("Required field!"),
  //   CountryCode: yup.string().default(cityName).required("Required field!"),
  // });
  const [subDiv, setSubDiv] =  useState([{SubdCode : null, SubdName:"None"}]);
  const [subDivLoading, setSubDivLoading] = useState(false);
  const {isMaintainer} = useContext(OrgIdContext);

  const {
    register,
    reset,
    formState: { errors },
    control,
    setValue,
  } = useFormContext();

  useEffect(() => {
    if (shouldReset) {
      reset();
      onFormReset();
    }
  }, [shouldReset, reset, onFormReset]);

  useEffect(()=>{
    //console.log(profileData);
    onCountryChange({target: {value : profileData.org.CountryCode}}, false)
  },[])

  const onCountryChange = (e, reset) =>{
    let empty = {SubdCode : null, SubdName:"None"};
    if(reset!==false)
      setValue("CounSubd" , null);
    setSubDiv([]);
    setSubDivLoading(true);
    e2Data.filter = `CounCode="${e.target.value}" AND (NotVisible=false OR NotVisible=null)`
    e2Data.GetData().then(res => {
      setSubDivLoading(false);
      setSubDiv([empty, ...res?.result?.data] || [empty]);
    });
  }

  return (
    <div className={classes.container}>
      <fieldset className={classes["input-container"]} disabled={!isEditMode}>
        <label htmlFor="name">{t("Name of your legal entity")}*</label>
        <input
          type="text"
          name="Name"
          id="name"
          {...register("Name")}
          // defaultValue={name}
          placeholder={t("Name of the business")}
        />
        {errors.Name && <p className={classes.error}>{errors.Name?.message}</p>}
      </fieldset>

       <fieldset className={classes["input-container"]} disabled={!isEditMode}>
        <label htmlFor="NameShort">{t("Short name")}</label>
        <input
          type="text"
          name="NameShort"
          id="NameShort"
          {...register("NameShort")}
          // defaultValue={name}
          placeholder={t("Short name of the business")}
        />
        {errors.NameShort && <p className={classes.error}>{errors.NameShort?.message}</p>}
      </fieldset>
      
      <fieldset className={classes["input-container"]} disabled={!isEditMode}>
        <label htmlFor="countryCode">{t("Country")}*
          <OverlayTrigger placement="top" overlay={<Tooltip>{t("Code of a country.")}</Tooltip>}>
              <HelpOutlineIcon style={{marginLeft:"0.3rem", fontSize:"1rem"}}/>
            </OverlayTrigger>
        </label>
        <Controller
          // type="text"
          name="CountryCode"
          id="countryCode"
          control={control}
          render={({ field }) => {
            return (
              <select {...field} onChange={(e) =>{
                onCountryChange(e);
                field.onChange(e);
              }}>
                {countriesList.map((country) => {
                  return (
                    <option
                      value={country.CountryCodeISOC2}
                      key={country.CountryCodeISOC2}
                    >
                      {country.CountryNameOriginal} ({country.CountryCodeISOC2})
                    </option>
                  );
                })}
              </select>
            );
          }}
          // defaultValue={countryCode ? countryCode : ""}
          // onChange={onInputChangeHandler}
        />
        {/* {countriesList.length === 0 && <p>empty</p>} */}
        <p className={classes.error}>{errors.CountryCode?.message}</p>
      </fieldset>

      <fieldset className={classes["input-container"]} disabled={!isEditMode}>
        <label htmlFor="address">{t("Address")}*</label>
        <input
          type="text"
          name="Address"
          id="address"
          {...register("Address")}
          placeholder={t("Address of the business")}
        />
        <p className={classes.error}>{errors.Address?.message}</p>
      </fieldset>

      <fieldset className={classes["input-container"]} disabled={!isEditMode}>
        <label htmlFor="postCode">{t("Postal Code")}*</label>
        <input
          type="text"
          name="PostCode"
          id="postCode"
          {...register("PostCode")}
          placeholder={t("Post code")}
        />
        <p className={classes.error}>{errors.PostCode?.message}</p>
      </fieldset>

      {sessionInfo?.Extended?.CountryCode === "TH" && <>
        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="BuildingNum">
          {t("Building Number")}
            {errors.BuildingNum && <>
              <WarningTooltip text={errors.BuildingNum?.message}/>
              
            </>}
          </label>
          <input
            type="text"
            name="BuildingNum"
            id="BuildingNum"
            style={errors.BuildingNum ? {outlineColor:"red"}: {}}
            {...register("BuildingNum")}
          />
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="BuildingName">
          {t("Building Name")}
            {errors.BuildingName && <>
              <WarningTooltip text={errors.BuildingName?.message}/>
              
            </>}
          </label>
          <input
            type="text"
            name="BuildingName"
            id="BuildingName"
            style={errors.BuildingName ? {outlineColor:"red"}: {}}
            {...register("BuildingName")}
          />
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="CitySubdName">
          {t("City Subdivision Name")}
            {errors.CitySubdName && <>
              <WarningTooltip text={errors.CitySubdName?.message}/>
              
            </>}
          </label>
          <input
            type="text"
            name="CitySubdName"
            id="CitySubdName"
            style={errors.CitySubdName ? {outlineColor:"red"}: {}}
            {...register("CitySubdName")}
          />
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="cityName">{t("City Subdivision Code")}</label>
          <input
            type="text"
            name="CitySubdCode"
            id="CitySubdCode"
            {...register("CitySubdCode")}
            placeholder={t("City Subdivision Code")}
          />
          <p className={classes.error}>{errors.CitySubdCode?.message}</p>
        </fieldset>
      </>}

      <fieldset className={classes["input-container"]} disabled={!isEditMode}>
        <label htmlFor="cityName">{t("City Name")}*</label>
        <input
          type="text"
          name="CityName"
          id="cityName"
          {...register("CityName")}
          placeholder={t("City Name")}
        />
        <p className={classes.error}>{errors.CityName?.message}</p>
      </fieldset>

      <fieldset className={classes["input-container"]} disabled={!isEditMode}>
        <label htmlFor="cityName">{t("City Code")}
          <OverlayTrigger placement="top" overlay={<Tooltip>{t("A code for specifying a certain area of a city e.g. district")}</Tooltip>}>
              <HelpOutlineIcon style={{marginLeft:"0.3rem", fontSize:"1rem"}}/>
            </OverlayTrigger>
        </label>
        <input
          type="text"
          name="CityCode"
          id="CityCode"
          {...register("CityCode")}
          placeholder={t("City code")}
        />
        <p className={classes.error}>{errors.CityCode?.message}</p>
      </fieldset>

      
      <fieldset className={classes["input-container"]} disabled={!isEditMode}>
        <label htmlFor="counSubd">{t("Subdivision")}
          <OverlayTrigger placement="top" overlay={<Tooltip>{t("A code to specify a certain subdivision/area of a country.")}</Tooltip>}>
              <HelpOutlineIcon style={{marginLeft:"0.3rem", fontSize:"1rem"}}/>
            </OverlayTrigger>
        </label>
        {/* <div className="d-inline-flex"> */}
        <Controller
          // type="text"
          name="CounSubd"
          id="counSubd"
          control={control}
          render={({ field }) => {
            return (
              <select {...field}>
                {subDiv.map((subdivision) => {
                  return (
                    <option
                      value={subdivision.SubdCode}
                      key={subdivision.SubdCode}
                    >
                      {subdivision.SubdName} {subdivision.SubdCode && <>({subdivision.SubdCode})</>}
                    </option>
                  );
                })}
              </select>
            );
          }}
        />
      </fieldset>
      <fieldset className={classes["input-container"]} disabled={!isMaintainer}>
        <label htmlFor="CountryCodeSC">
          {t("Legislation of invoices")}
          <OverlayTrigger placement="top" overlay={<Tooltip>{t("Select the country whose tax legislation and sales rules will apply to invoices. If a specific country isn't available, the system defaults to an EU country. Need a different option? Reach out to our support team.")}</Tooltip>}>
            <HelpOutlineIcon style={{marginLeft:"0.3rem", fontSize:"1rem"}}/>
          </OverlayTrigger>
        </label>
        <Controller
          name="CountryCodeSC"
          id="CountryCodeSC"         
          control={control}
          render={({ field }) => {
            return (
              <select {...field}>
                {scrList.map((scr) => {
                  return (
                    <option
                      value={scr.Id}
                      key={scr.CountryCode}
                    >
                      {scr.CountryCode}
                    </option>
                  );
                })}
              </select>
            );
          }}
        />
      </fieldset>
      <fieldset className={classes["input-container"]} disabled={!isEditMode}>
        <label htmlFor="cityName">{t("Website")}</label>
        <input
          type="text"
          name="WebForValidation"
          id="webForValidation"
          {...register("WebForValidation")}
          placeholder={t("Website")}
        />
        <p className={classes.error}>{errors.WebForValidation?.message}</p>
      </fieldset>
    </div>
  );
};

export default GeneralInfo;
